<template>
  <li @click="$emit('onSelected', thread)" :class="[{ active: thread.id === currentThread.id }, { processing: thread.processing }]" @dblclick.stop="startEditing">
    <span v-if="editingId !== thread.id">
      {{ thread.name || 'Без имени' }} 
      <!-- <div class="threadId">{{ thread.id }}</div> -->
      <div class="date"> {{ createdAt }} </div>
      <button class="delete-btn" @click.stop="$emit('onDelete', thread.id)" title="Удалить">
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="3 6 5 6 21 6"/>
          <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
          <path d="M10 11v6"/>
          <path d="M14 11v6"/>
          <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
        </svg>
      </button>
    </span>
    <input
      v-else
      v-model="editingName"
      @keyup.enter="finishEditing"
      @keyup.esc="cancelEditing"
      ref="editInput"
    />
  </li>
</template>

<script>
import { yandexApi } from './api/yandex-api';

const formatter = new Intl.DateTimeFormat("ru-RU", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false
});

export default {
  name: 'ChatItem',
  props: {
    thread: {
      type: Object,
      required: true
    },
    currentThread: {
      type: Object,
      default: null
    },
    update: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      editingId: null,
      wasActive: false,
      editingName: ''
    };
  },
  computed: {
    createdAt() {
      const utcDate = new Date(this.thread.createdAt + "Z");
      return formatter.format(utcDate);
    }
  },   
  watch: {
    currentThread(newVal, oldVal) {
      // если раньше был активным, а теперь нет
      if (this.thread.id !== newVal.id) {
        this.finishEditing();
        this.wasActive = false;
      }

      // обновляем wasActive
      if (this.thread.id === newVal.id) {
        this.wasActive = true;
      }
    },
    async 'thread.name'(newVal, oldVal) {
      try {
        //this.thread.processing = true;
        if (newVal !== oldVal) {
          const runBody = {
              id: this.thread.id,
              name: this.thread.name,
          };
          await yandexApi.patch(`/thread`, runBody);
        }
      } finally {
        //this.thread.processing = false;
      }
    }
  },
  methods: {
    startEditing() {
      this.editingId = this.thread.id;
      this.editingName = this.thread.name || '';
      this.$nextTick(() => {
        this.$refs.editInput.focus();
      });
    },
    finishEditing() {
      if (this.editingName.trim() !== this.thread.name && this.editingName.trim() !== '') {
        this.thread.name = this.editingName.trim();
        this.$emit('onEdited', this.thread);
      }
      
      this.editingId = null;
      this.editingName = '';
    },
    cancelEditing() {
      this.editingId = null;
      this.editingName = '';
    }
  }
};
</script>

<style scoped>
.threadId {
  color: #888;
  padding-top: 5px;
  font-size: 0.6em;
}

.date {
  color: #757474;
  padding: 7px 0px 0px 0px;
  font-size: 0.6em;
}

input {
  width: 100%;
}

li {
  position: relative; /* нужно для позиционирования иконки */
  list-style: none;
  padding: 15px 10px 10px 15px;
  cursor: pointer;
  text-align: left;
  border-radius: 10px 10px 10px 10px;
  overflow: hidden;
}

li:hover {
  background: #e4e4e4;
}

.active {
    background: #ccc;
    padding: 15px 10px 10px 15px;
}

.delete-btn {
  position: absolute;
  bottom: 5px;
  right: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 2px;
  opacity: 0.6;
  transition: opacity 0.2s;
}

.delete-btn:hover {
  opacity: 1;
}

.icon {
  width: 15px;
  height: 15px;
  stroke: rgb(177, 177, 177);
}

.delete-btn:hover .icon {
  stroke: rgb(129, 129, 129);
}

/* Переливающаяся полоска внутри li */
li.processing::before {
  content: "";
  position: absolute;
  top: 0;                      /* строго внутри, у самого верха */
  left: 0;
  right: 0;
  height: 3px;
  pointer-events: none;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.199) 0%,
    rgba(0, 0, 0, 0) 50%,
    rgba(0,0,0,0.12) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 3s linear infinite;
  /* верхние углы повторяют скругление родителя */
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  z-index: 1;
}

@keyframes shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

</style>



// WEBPACK FOOTER //
// src/components/chat-item.vue